class LinkedProducts extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#LinkedProducts-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderAccessibility();
  }

  setHeaderAccessibility() {
    const linkedProductsButton = document.querySelector("#linked-products");
    linkedProductsButton.addEventListener("click", () => {
      this.open(linkedProductsButton);
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.querySelector("#LinkedProducts");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("linked-products", LinkedProducts);
